import axios from 'axios'
import { buildQuery } from '../exports/queryStringBuilder'

export default {
    async fetchAll(query, filters,page) {
        return await axios.get(`order-asset-rental?q=${query}&page=${page}&` + buildQuery(filters),{
            headers: {
                'Content-Encoding': 'gzip',
              }
        })
    },
    async fetchByPermission() {
        return await axios.get(`order-asset-rental/fetchby/permission`)
    },
    async create(model) {
        return await axios.post(`order-asset-rental`, model)
    },
    async fetchById(id) {
        return await axios.get(`order-asset-rental/${id}`)
    },

    async update(id, model) {
        return await axios.put(`order-asset-rental/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`order-asset-rental/${id}`)
    },

    async fetchActivityTransactions(query, filters) {
        return await axios.get(`order-asset-rental/activity-transactions?q=${query}&` + buildQuery(filters),{
            headers: {
                'Content-Encoding': 'gzip',
              }
        })
    },
    async fetchorder() {
        return await axios.get(`order-asset-rental/activity`)
    },

    async fetchcustomer(){
        return await axios.get(`order-asset-rental/customer`)
    },

    async fetchBank(){
        return await axios.get(`order-asset-rental/bank`)
    },

    async exportExcel(query, filters,exportExcel){
        return await axios.get(`order-asset-rental?q=${query}&export_csv=${exportExcel}&` + buildQuery(filters),{
            responseType: 'blob'
        })
    },
    async exportPDF(query, filters,exportPDF,export_option){
        return await axios.get(`order-asset-rental?q=${query}&export_pdf=${exportPDF}&export_option=${export_option}&` + buildQuery(filters),{
            responseType: 'blob'
        })
    },
    async exportExcelOrderTransaction(query, filters,exportExcel){
        return await axios.get(`order-asset-rental/activity-transactions?q=${query}&export_csv=${exportExcel}&` + buildQuery(filters),{
            responseType: 'blob'
        })
    },
    
}
